// Hungary map metadata and city positions for the original SVG.
// The original map is stored in public/hungary_map.svg and is rendered at its native aspect ratio.
// Source: https://commons.wikimedia.org/wiki/File:Hungary_location_map.svg
// © NordNordWest, CC BY-SA 3.0

export const MAP_SRC = '/hungary_map.svg'
export const VIEWBOX = { width: 1209.727, height: 746.20312 }

// Coordinates are derived from the same bounding box as the original map.
export const CITY_COORDS: Record<string, { cx: number; cy: number }> = {
  Budapest: { cx: 538.8, cy: 294.4 },
  'Üllő': { cx: 589.6, cy: 319.7 },
  'Gyömrő': { cx: 596.2, cy: 310.0 },
  'Balatonberény': { cx: 261.4, cy: 473.2 },
  'Alsómocsolád': { cx: 411.3, cy: 561.5 },
  'Gádoros': { cx: 787.7, cy: 482.4 },
  'Szentistván': { cx: 800.9, cy: 235.0 },
}
